import {excess} from '@fl/cmsch-fe-library';
import * as t from 'io-ts';

const requiredPart = excess(t.partial({
    approvedFrom: t.string,
    approvedTo: t.string,
    organizationCenterIds: t.string,
    farmIds: t.string,
    roleIds: t.string,
    organizationId: t.string,
}));

export const ValidateOrganizationErrorsSchema = t.interface({binding: requiredPart});
